import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper pricing3-wrapper pricing3',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page pricing3-page',
    },
    OverPack: {
      playScale: 0.3,
      className: 'pricing3',
    },
    leftImg: {
      className: 'pricing3-img',
      name: 'image',
      children: 'https://86imm.oss-cn-hangzhou.aliyuncs.com/assets/landing/pricing/bitmap.png',
    },
    right: {
      name: 'right',
      className: 'right',
      children: [
        {
          name: 'box0',
          className: 'right-box',
          title: {
            name: 'title',
            children: '人才优势',
            className: 'right-box-title',
          },
          content: {
            name: 'content',
            className: 'right-box-content',
            children: [
              {
                name: 'img',
                children: 'https://imm.86links.com/assets/landing/pricing/template/pricing-icon.png',
                className: 'right-box-content-icon',
              },
              {
                name: 'text',
                children: '百余所高校，两院院士123人，2021年高校毕业超50万人。',
                className: 'right-box-content-text',
              },
            ],
          },
          row: {
            name: 'row',
            className: 'right-box-row row3',
            children: [
              {
                name: 'item0',
                children: '四川大学',
                className: 'right-box-row-item',
              },
              {
                name: 'item1',
                children: '成都理工大学',
                className: 'right-box-row-item',
              },
              {
                name: 'item2',
                children: '电子科技大学',
                className: 'right-box-row-item',
              },
              {
                name: 'item3',
                children: '西南财经大学',
                className: 'right-box-row-item',
              },
              {
                name: 'item4',
                children: '西南交通大学',
                className: 'right-box-row-item',
              },
              {
                name: 'item5',
                children: '四川师范大学',
                className: 'right-box-row-item',
              },
            ],
          },
        },
        {
          name: 'box1',
          className: 'right-box',
          title: {
            name: 'title',
            children: '政务环境',
            className: 'right-box-title',
          },
          content: {
            name: 'content',
            className: 'right-box-content',
            children: [],
          },
          row: {
            name: 'row',
            className: 'right-box-row',
            children: [
              {
                name: 'item0',
                children: '鼓励<strong style="font-size:16px;color:#129da4">项目落地开工</strong>快投快建',
                className: 'right-box-row-item',
              },
              {
                name: 'item1',
                children: '鼓励<strong style="font-size:16px;color:#129da4">企业稳产扩产</strong>做大做强',
                className: 'right-box-row-item',
              },
              {
                name: 'item2',
                children: '鼓励<strong style="font-size:16px;color:#129da4">重点领域</strong>加快补短提质',
                className: 'right-box-row-item',
              },
              {
                name: 'item3',
                children: '鼓励<strong style="font-size:16px;color:#129da4">创新发展</strong>加快动能培育',
                className: 'right-box-row-item',
              },
            ],
          },
        },
      ],
    },
  },
};
